import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Web3Address } from 'multirpc-sdk';

import { RootState } from 'store';

interface ISetTokenIndexPayload {
  tokenIndex: number;
  address: Web3Address;
}

interface ISetSelectedProjectPayload {
  selectedProject?: string;
  address: Web3Address;
}

interface ITokenManagerConfigPayload {
  shouldShowTokenManager?: boolean;
  selectedProject?: string;
  address?: Web3Address;
  tokenIndex: number;
}

export type IJwtTokenManagerSlice = Record<
  Web3Address,
  ITokenManagerConfigPayload
>;

const initialState: IJwtTokenManagerSlice = {};

const EMPTY_CONFIG = {
  selectedProject: undefined,
  tokenIndex: -1,
};

export const jwtTokenManagerSlice = createSlice({
  name: 'jwtTokenManager',
  initialState,
  reducers: {
    // uses for jwt manager component
    setSelectedTokenIndex: (
      state,
      action: PayloadAction<ISetTokenIndexPayload>,
    ) => {
      const { address, tokenIndex } = action.payload;

      state[address] = {
        ...state[address],
        address,
        tokenIndex,
      };
    },
    // uses for selects, when we need only endpoint token
    setSelectedProjectEndpointToken: (
      state,
      action: PayloadAction<ISetSelectedProjectPayload>,
    ) => {
      const { address, selectedProject } = action.payload;

      state[address] = {
        ...state[address],
        address,
        selectedProject,
      };
    },
    resetSelectedProjectEndpointToken: (
      state,
      action: PayloadAction<ISetSelectedProjectPayload>,
    ) => {
      const { address } = action.payload;

      state[address] = EMPTY_CONFIG;
    },
    resetSelectedProjectEndpointTokenIfDeleted: (
      state,
      action: PayloadAction<ISetTokenIndexPayload>,
    ) => {
      const { address, tokenIndex } = action.payload;

      if (state[address]?.tokenIndex === tokenIndex) {
        state[address] = EMPTY_CONFIG;
      }
    },
  },
});

export const selectTokenManagerConfig = (
  state: RootState,
  currentAccount: Web3Address,
) => state.jwtTokenManager[currentAccount] || {};

export const {
  resetSelectedProjectEndpointToken,
  resetSelectedProjectEndpointTokenIfDeleted,
  setSelectedProjectEndpointToken,
  setSelectedTokenIndex,
} = jwtTokenManagerSlice.actions;
